import axios from 'axios'
// import {BASE_API_URL} from '@/config/AppConfig'

let checkResponse = function (response, successStatus = 200) {
  if (undefined === response || response === null) {
    return false
  }

  if (undefined === response.status || response.status === null) {
    return false
  }

  if (undefined !== successStatus && successStatus !== null && response.status !== successStatus) {
    return false
  }

  return true
}
let checkEmptyObject = function (currentObject, keysArray) {
  if (undefined === currentObject || currentObject === null) {
    return false
  }
  for (let i = 0; i < keysArray.length; i++) {
    let currentKey = keysArray[i]
    if (undefined === currentObject[currentKey] || currentObject[currentKey] === null) {
      return false
    }
  }
  return true
}

export function makeApiCall (uri, method = 'GET', data, params, responseStatusToCheck = null, responseKeysToCheck = []) {
  return new Promise((resolve, reject) => {
    axios({
      url: uri,
      method: method,
      data,
      params
    }).then((response) => {
      if (checkResponse(response, responseStatusToCheck) === false) {
        reject(response)
      }
      let data = response.data
      if (responseKeysToCheck.length < 1 && checkEmptyObject(data, responseKeysToCheck) === false) {
        reject(response)
      }
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/apiService.js